import React, { forwardRef, useCallback, useImperativeHandle, useMemo } from 'react'
import Select from 'react-select';
import CustomColumn from '../../../../../customControl/CustomColumn';
import { alphaNumericspace, isValidEmail, onlyNumeric } from '../../../../commonClass/CommonValidation';

const ActivityMeetingPointAddressSection = forwardRef(({ PointAddressForm, setPointAddressForm, formErrors, setFormErrors, dropdownData, disabled, setEditDisabled, ActivityId }, ref) => {

    //#region get state list based on selected activity
    const getStateList = useMemo(() => {
        return dropdownData?.activityList?.find((prev) => prev?.value === ActivityId)?.StateList || [];
    }, [dropdownData?.activityList, ActivityId])
    //#endregion

    //#region get city data based on selected state
    const getCityList = useCallback((IsActivePointAddress) => {
        const StateId = PointAddressForm?.ActivityBasicInfoAddress?.find((prev) => prev?.IsActivePointAddress === IsActivePointAddress)?.StateId || 0;
        return getStateList?.find((prev) => prev?.value === StateId)?.CityList || [];
    }, [getStateList, PointAddressForm?.ActivityBasicInfoAddress])
    //#endregion

    //#region get form values
    const getAddressValues = (IsActivePointAddress, label) => {
        return PointAddressForm?.ActivityBasicInfoAddress?.find((prev) => prev?.IsActivePointAddress === IsActivePointAddress)?.[label]
    }
    //#endregion

    //#region on change functions
    const handleChangeRadio = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        setPointAddressForm((prev) => ({ ...prev, [name]: value }));
        if (value === true) {
            const activity = PointAddressForm?.ActivityBasicInfoAddress?.find((prev) => prev?.IsActivePointAddress === true);
            const updateActivityBasicInfoAddress = PointAddressForm?.ActivityBasicInfoAddress?.map((obj) => {
                if (obj?.IsActivePointAddress === false) {
                    const keys = Object.keys(activity)
                    keys?.map((key) => {
                        obj[key] = activity?.[key];
                    })
                    obj.IsActivePointAddress = false;
                }
                return obj;
            })

            setPointAddressForm((prev) => ({ ...prev, ActivityBasicInfoAddress: updateActivityBasicInfoAddress }))
        }
    }
    const handleOnChangeAddress = (IsActivePointAddress, name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        const updateActivityBasicInfoAddress = PointAddressForm?.ActivityBasicInfoAddress?.map((obj) => {
            if (obj?.IsActivePointAddress === IsActivePointAddress) {
                if (name === "StateId") {
                    obj.StateId = value;
                    obj.LocationId = 0;
                }
                else {
                    obj[name] = value;
                }
            }
            return obj;
        })
        setPointAddressForm((prev) => ({ ...prev, ActivityBasicInfoAddress: updateActivityBasicInfoAddress }))
    }
    //#endregion

    //#region validations
    const ValidateActivityMeetingPointAddressForm = () => {
        let error = {};


        const activityPointAddress = PointAddressForm?.ActivityBasicInfoAddress?.find((prev) => prev.IsActivePointAddress === true);
        const meetingPointAddress = PointAddressForm?.ActivityBasicInfoAddress?.find((prev) => prev.IsActivePointAddress === false);

        if (!activityPointAddress?.StateId || activityPointAddress?.StateId <= 0) {
            error.ActivityPointStateId = "Cannot leave blank, input is mandatory.";
        }
        if (!activityPointAddress?.LocationId || activityPointAddress?.LocationId <= 0) {
            error.ActivityPointCityId = "Cannot leave blank, input is mandatory.";
        }
        if (activityPointAddress?.PinCode?.trim()?.length <= 0 || !activityPointAddress?.PinCode) {
            error.ActivityPointPincode = "Cannot leave blank, input is mandatory.";
        }
        if (activityPointAddress?.AddressLine?.trim()?.length <= 0 || !activityPointAddress?.AddressLine) {
            error.ActivityPointAddress = "Cannot leave blank, input is mandatory.";
        }



        if (!meetingPointAddress?.StateId || meetingPointAddress?.StateId <= 0) {
            error.MeetingPointStateId = "Cannot leave blank, input is mandatory.";
        }
        if (!meetingPointAddress?.LocationId || meetingPointAddress?.LocationId <= 0) {
            error.MeetingPointCityId = "Cannot leave blank, input is mandatory.";
        }
        if (meetingPointAddress?.PinCode?.trim()?.length <= 0 || !meetingPointAddress?.PinCode) {
            error.MeetingPointPincode = "Cannot leave blank, input is mandatory.";
        }
        if (meetingPointAddress?.MobileNo?.trim()?.length <= 0 || !meetingPointAddress?.MobileNo) {
            error.MeetingPointMobileNo = "Cannot leave blank, input is mandatory.";
        }
        // if (meetingPointAddress?.MobileNo?.trim()?.length > 0 && meetingPointAddress?.MobileNo?.trim()?.length < 10) {
        //     error.MeetingPointMobileNo = "Kindly enter the correct mobile number"
        // }
        // if (meetingPointAddress?.EmailId?.trim()?.length <= 0 || !meetingPointAddress?.EmailId) {
        //     error.MeetingPointEmailId = "Cannot leave blank, input is mandatory.";
        // }
        if (meetingPointAddress?.EmailId?.trim()?.length > 0 && !isValidEmail(meetingPointAddress?.EmailId)) {
            error.MeetingPointEmailId = "Email Id should in a format abc@xyz.com.";
        }
        if (meetingPointAddress?.AddressLine?.trim()?.length <= 0 || !meetingPointAddress?.AddressLine) {
            error.MeetingPointAddress = "Cannot leave blank, input is mandatory.";
        }

        return error;
    }
    //#endregion

    // Expose the childFunction to the parent's ref
    useImperativeHandle(ref, () => ({
        canValidate: true,
        ValidateActivityMeetingPointAddressForm: ValidateActivityMeetingPointAddressForm
    }))


    return (
        <>
            <div className="container-fluid form_border my-2 py-3">
                <div className="row">
                    {/* Activity Point Address */}
                    <div className="col-md-6 col-12">
                        <div className="row">
                            <div className="col-12 invisible">
                                <CustomColumn colNum={12} colLabel={8} colMDLabel={8} colChildren={4} colMDChildren={4} classChildren="align-content-center" labelText='Is the Meeting Point address the same as the activity address?' labelId='SameAddressRadio' >
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    name="sameaddresstest"
                                                    value={1}
                                                    disabled
                                                />
                                                <label className="form-check-label"> Yes </label>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    name="sameaddresstest"
                                                    value={2}
                                                    disabled
                                                />
                                                <label className="form-check-label"> No </label>
                                            </div>
                                        </div>
                                    </div>
                                </CustomColumn>
                            </div>

                            <div className="col-12">
                                <h5 className="mb-3">
                                    <strong>Activity Point Address</strong>
                                </h5>
                            </div>

                            <CustomColumn colNum={12} labelText='State' labelId='ActivityPointStateId' isRequired >
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='ActivityPointStateId'
                                    options={getStateList}
                                    value={getStateList?.find((obj) => obj?.value === getAddressValues(true, "StateId")) || 0}
                                    onChange={(e) => handleOnChangeAddress(true, "StateId", e ? e?.value : 0)}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='State'
                                />
                                {formErrors?.ActivityPointStateId && <div className="text-danger text-start fs_14">{formErrors?.ActivityPointStateId}</div>}
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='City' labelId='ActivityPointCityId' isRequired >
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='ActivityPointCityId'
                                    options={getCityList(true)}
                                    value={getCityList(true)?.find((obj) => obj?.value === getAddressValues(true, "LocationId")) || 0}
                                    onChange={(e) => handleOnChangeAddress(true, "LocationId", e ? e?.value : 0)}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='City'
                                />
                                {formErrors?.ActivityPointCityId && <div className="text-danger text-start fs_14">{formErrors?.ActivityPointCityId}</div>}
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Pin Code' labelId='ActivityPointPincode' isRequired >
                                <input
                                    type="text"
                                    className='form-control'
                                    name="PinCode"
                                    id="ActivityPointPincode"
                                    value={getAddressValues(true, "PinCode")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 20 &&
                                        handleOnChangeAddress(true, e.target.name, onlyNumeric(e.target.value))
                                    }
                                    maxLength={20}
                                    disabled={disabled ? true : false}
                                    placeholder='Pin Code'
                                />
                                {formErrors?.ActivityPointPincode && <div className="text-danger text-start fs_14">{formErrors?.ActivityPointPincode}</div>}
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Choose Landmark' labelId='ActivityPointLandmark' >
                                <input
                                    type="text"
                                    className='form-control'
                                    name="Landmark"
                                    id="ActivityPointLandmark"
                                    value={getAddressValues(true, "Landmark")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 200 &&
                                        handleOnChangeAddress(true, e.target.name, e.target.value)
                                    }
                                    maxLength={200}
                                    disabled={disabled ? true : false}
                                    placeholder='Choose Landmark'
                                />
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Latitude' labelId='ActivityPointLatitude' >
                                <input
                                    type="text"
                                    className='form-control'
                                    name="Latitude"
                                    id="ActivityPointLatitude"
                                    value={getAddressValues(true, "Latitude")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 200 &&
                                        handleOnChangeAddress(true, e.target.name, e.target.value)
                                    }
                                    maxLength={200}
                                    disabled={disabled ? true : false}
                                    placeholder='Latitude'
                                />
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Longitude' labelId='ActivityPointLongtitude'>
                                <input
                                    type="text"
                                    className='form-control'
                                    name="Longitude"
                                    id="ActivityPointLongtitude"
                                    value={getAddressValues(true, "Longitude")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 200 &&
                                        handleOnChangeAddress(true, e.target.name, e.target.value)
                                    }
                                    maxLength={200}
                                    disabled={disabled ? true : false}
                                    placeholder='Longitude'
                                />
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Address' labelId='ActivityPointAddress' isRequired >
                                <textarea
                                    className='form-control'
                                    name="AddressLine"
                                    id="ActivityPointAddress"
                                    value={getAddressValues(true, "AddressLine")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 200 &&
                                        handleOnChangeAddress(true, e.target.name, alphaNumericspace(e.target.value))
                                    }
                                    maxLength={200}
                                    disabled={disabled ? true : false}
                                    placeholder='Address'
                                    rows={3}
                                />
                                {formErrors?.ActivityPointAddress && <div className="text-danger text-start fs_14">{formErrors?.ActivityPointAddress}</div>}
                            </CustomColumn>

                        </div>
                    </div>
                    {/* Activity Point Address */}

                    {/* Meeting Point Address */}
                    <div className="col-md-6 col-12">
                        <div className="row">
                            <div className="col-12">
                                <CustomColumn colNum={12} colLabel={8} colMDLabel={8} colChildren={4} colMDChildren={4} classChildren="align-content-center" labelText='Is the Meeting Point address the same as the activity address?' labelId='SameAddressRadio' >
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    id="sameaddressyes"
                                                    className="form-check-input"
                                                    name="sameaddress"
                                                    value={1}
                                                    checked={PointAddressForm?.IsMeetingPointSameAsActivityAddress}
                                                    onChange={(e) => handleChangeRadio("IsMeetingPointSameAsActivityAddress", true)}
                                                    disabled={disabled}
                                                />
                                                <label htmlFor="sameaddressyes" className="form-check-label"> Yes </label>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    id="sameaddressno"
                                                    className="form-check-input"
                                                    name="sameaddress"
                                                    value={2}
                                                    checked={!PointAddressForm?.IsMeetingPointSameAsActivityAddress}
                                                    onChange={(e) => handleChangeRadio("IsMeetingPointSameAsActivityAddress", false)}
                                                    disabled={disabled}
                                                />
                                                <label htmlFor="sameaddressno" className="form-check-label"> No </label>
                                            </div>
                                        </div>
                                    </div>
                                </CustomColumn>
                            </div>

                            <div className="col-12">
                                <h5 className="mb-3">
                                    <strong>Meeting Point Address</strong>
                                </h5>
                            </div>

                            <CustomColumn colNum={12} labelText='State' labelId='MeetingPointStateId' isRequired >
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='MeetingPointStateId'
                                    options={getStateList}
                                    value={getStateList?.find((obj) => obj?.value === getAddressValues(false, "StateId")) || 0}
                                    onChange={(e) => handleOnChangeAddress(false, "StateId", e ? e?.value : 0)}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='State'
                                />
                                {formErrors?.MeetingPointStateId && <div className="text-danger text-start fs_14">{formErrors?.MeetingPointStateId}</div>}
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='City' labelId='MeetingPointCityId' isRequired >
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='MeetingPointCityId'
                                    options={getCityList(false)}
                                    value={getCityList(false)?.find((obj) => obj?.value === getAddressValues(false, "LocationId")) || 0}
                                    onChange={(e) => handleOnChangeAddress(false, "LocationId", e ? e?.value : 0)}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='City'
                                />
                                {formErrors?.MeetingPointCityId && <div className="text-danger text-start fs_14">{formErrors?.MeetingPointCityId}</div>}
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Pin Code' labelId='MeetingPointPincode' isRequired >
                                <input
                                    type="text"
                                    className='form-control'
                                    name="PinCode"
                                    id="MeetingPointPincode"
                                    value={getAddressValues(false, "PinCode")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 20 &&
                                        handleOnChangeAddress(false, e.target.name, onlyNumeric(e.target.value))
                                    }
                                    maxLength={20}
                                    disabled={disabled ? true : false}
                                    placeholder='Pin Code'
                                />
                                {formErrors?.MeetingPointPincode && <div className="text-danger text-start fs_14">{formErrors?.MeetingPointPincode}</div>}
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Choose Landmark' labelId='MeetingPointLandmark' >
                                <input
                                    type="text"
                                    className='form-control'
                                    name="Landmark"
                                    id="MeetingPointLandmark"
                                    value={getAddressValues(false, "Landmark")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 200 &&
                                        handleOnChangeAddress(false, e.target.name, e.target.value)
                                    }
                                    maxLength={200}
                                    disabled={disabled ? true : false}
                                    placeholder='Choose Landmark'
                                />
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Latitude' labelId='MeetingPointLatitude' >
                                <input
                                    type="text"
                                    className='form-control'
                                    name="Latitude"
                                    id="MeetingPointLatitude"
                                    value={getAddressValues(false, "Latitude")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 200 &&
                                        handleOnChangeAddress(false, e.target.name, e.target.value)
                                    }
                                    maxLength={200}
                                    disabled={disabled ? true : false}
                                    placeholder='Latitude'
                                />
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Longitude' labelId='MeetingPointLongtitude'>
                                <input
                                    type="text"
                                    className='form-control'
                                    name="Longitude"
                                    id="MeetingPointLongtitude"
                                    value={getAddressValues(false, "Longitude")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 200 &&
                                        handleOnChangeAddress(false, e.target.name, e.target.value)
                                    }
                                    maxLength={200}
                                    disabled={disabled ? true : false}
                                    placeholder='Longitude'
                                />
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Mobile Number' labelId='MeetingPointMobileNo' isRequired>
                                <input
                                    type="text"
                                    className='form-control'
                                    name="MobileNo"
                                    id="MeetingPointMobileNo"
                                    value={getAddressValues(false, "MobileNo")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 10 &&
                                        handleOnChangeAddress(false, e.target.name, onlyNumeric(e.target.value))
                                    }
                                    maxLength={10}
                                    disabled={disabled ? true : false}
                                    placeholder='Mobile Number'
                                />
                                {formErrors?.MeetingPointMobileNo && <div className="text-danger text-start fs_14">{formErrors?.MeetingPointMobileNo}</div>}
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Email' labelId='MeetingPointEmailId'>
                                <input
                                    type="text"
                                    className='form-control'
                                    name="EmailId"
                                    id="MeetingPointEmailId"
                                    value={getAddressValues(false, "EmailId")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 50 &&
                                        handleOnChangeAddress(false, e.target.name, e.target.value)
                                    }
                                    maxLength={50}
                                    disabled={disabled ? true : false}
                                    placeholder='Email'
                                />
                                {formErrors?.MeetingPointEmailId && <div className="text-danger text-start fs_14">{formErrors?.MeetingPointEmailId}</div>}
                            </CustomColumn>

                            <CustomColumn colNum={12} labelText='Address' labelId='MeetingAddress' isRequired >
                                <textarea
                                    className='form-control'
                                    name="AddressLine"
                                    id="MeetingPointAddress"
                                    value={getAddressValues(false, "AddressLine")}
                                    onChange={(e) =>
                                        e.target.value?.length <= 200 &&
                                        handleOnChangeAddress(false, e.target.name, alphaNumericspace(e.target.value))
                                    }
                                    maxLength={200}
                                    disabled={disabled ? true : false}
                                    placeholder='Meeting Point or Activity Address'
                                    rows={3}
                                />
                                {formErrors?.MeetingPointAddress && <div className="text-danger text-start fs_14">{formErrors?.MeetingPointAddress}</div>}
                            </CustomColumn>

                        </div>
                    </div>
                    {/* Meeting Point Address */}
                </div>
            </div>
        </>
    )
});

export default ActivityMeetingPointAddressSection